module.exports = __webpack_public_path__ + "static/media/arr-right.39514c2a.svg";